"use strict";
/**
 * This code was generated by generateTsPackage.
 * Do not edit it manually
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mintFromFixedPriceSaleWithEarlyAccessAllowlistV2 = exports.mintFromFixedPriceSaleV2 = exports.mintFromDutchAuctionV2 = exports.getWorldsNftAddress = exports.getSellerOf = exports.getSellerInfoFromDutchAuction = exports.getRevenueDistributionForMint = exports.getPriceAtTimeForDutchAuction = exports.getMarketUtilsAddress = exports.getFoundationTreasury = exports.getFixedPriceSaleV2 = exports.getFixedPriceSaleEarlyAccessAllowlistSupported = exports.getFethAddress = exports.getFeesAndRecipients = exports.getFees = exports.getDutchAuctionV2 = exports.getBuyerInfoFromDutchAuction = exports.getAvailableCountFromFixedPriceSale = exports.getApprovedRouterAddress = void 0;
exports.getApprovedRouterAddress = {
    parseOutput: (output) => {
        return {
            /** router (address) */
            router: output[0],
        };
    },
};
exports.getAvailableCountFromFixedPriceSale = {
    parseOutput: (output) => {
        return {
            /** numberThatCanBeMinted (uint256) */
            numberThatCanBeMinted: output[0],
        };
    },
};
exports.getBuyerInfoFromDutchAuction = {
    parseOutput: (output) => {
        return {
            /** outstandingRebateBalance (uint256) */
            outstandingRebateBalance: output[0],
            /** numberThatCanBeMinted (uint256) */
            numberThatCanBeMinted: output[1],
        };
    },
};
exports.getDutchAuctionV2 = {
    parseOutput: (output) => {
        return {
            /** maxPrice (uint256) */
            maxPrice: output[0],
            /** minPrice (uint256) */
            minPrice: output[1],
            /** limitPerAccount (uint256) */
            limitPerAccount: output[2],
            /** startTime (uint256) */
            startTime: output[3],
            /** endTime (uint256) */
            endTime: output[4],
            /** totalAvailableSupply (uint256) */
            totalAvailableSupply: output[5],
            /** totalMintedCount (uint256) */
            totalMintedCount: output[6],
            /** lastSalePrice (uint256) */
            lastSalePrice: output[7],
            /** currentPrice (uint256) */
            currentPrice: output[8],
            /** mintFeePerNftInWei (uint256) */
            mintFeePerNftInWei: output[9],
        };
    },
};
exports.getFees = {
    parseOutput: (output) => {
        return {
            /** protocolFeeAmount (uint256) */
            protocolFeeAmount: output[0],
            /** creatorRecipients (address payable[]) */
            creatorRecipients: output[1],
            /** creatorShares (uint256[]) */
            creatorShares: output[2],
            /** sellerRev (uint256) */
            sellerRev: output[3],
            /** buyReferrerFee (uint256) */
            buyReferrerFee: output[4],
            /** sellerReferrerFee (uint256) */
            sellerReferrerFee: output[5],
        };
    },
};
exports.getFeesAndRecipients = {
    parseOutput: (output) => {
        return {
            /** totalFees (uint256) */
            totalFees: output[0],
            /** creatorRev (uint256) */
            creatorRev: output[1],
            /** creatorRecipients (address payable[]) */
            creatorRecipients: output[2],
            /** creatorShares (uint256[]) */
            creatorShares: output[3],
            /** sellerRev (uint256) */
            sellerRev: output[4],
            /** seller (address payable) */
            seller: output[5],
        };
    },
};
exports.getFethAddress = {
    parseOutput: (output) => {
        return {
            /** fethAddress (address) */
            fethAddress: output[0],
        };
    },
};
exports.getFixedPriceSaleEarlyAccessAllowlistSupported = {
    parseOutput: (output) => {
        return {
            /** supported (bool) */
            supported: output[0],
        };
    },
};
exports.getFixedPriceSaleV2 = {
    parseOutput: (output) => {
        return {
            /** seller (address payable) */
            seller: output[0],
            /** price (uint256) */
            price: output[1],
            /** limitPerAccount (uint256) */
            limitPerAccount: output[2],
            /** numberOfTokensAvailableToMint (uint256) */
            numberOfTokensAvailableToMint: output[3],
            /** marketCanMint (bool) */
            marketCanMint: output[4],
            /** generalAvailabilityStartTime (uint256) */
            generalAvailabilityStartTime: output[5],
            /** earlyAccessStartTime (uint256) */
            earlyAccessStartTime: output[6],
            /** mintFeePerNftInWei (uint256) */
            mintFeePerNftInWei: output[7],
        };
    },
};
exports.getFoundationTreasury = {
    parseOutput: (output) => {
        return {
            /** treasuryAddress (address payable) */
            treasuryAddress: output[0],
        };
    },
};
exports.getMarketUtilsAddress = {
    parseOutput: (output) => {
        return {
            /** marketUtilsAddress (address) */
            marketUtilsAddress: output[0],
        };
    },
};
exports.getPriceAtTimeForDutchAuction = {
    parseOutput: (output) => {
        return {
            /** price (uint256) */
            price: output[0],
        };
    },
};
exports.getRevenueDistributionForMint = {
    parseOutput: (output) => {
        return {
            /** creatorRevenue (uint256) */
            creatorRevenue: output[0],
            /** protocolFee (uint256) */
            protocolFee: output[1],
        };
    },
};
exports.getSellerInfoFromDutchAuction = {
    parseOutput: (output) => {
        return {
            /** seller (address) */
            seller: output[0],
            /** creatorRevenueReadyForWithdrawal (bool) */
            creatorRevenueReadyForWithdrawal: output[1],
            /** creatorRevenueHasBeenWithdrawn (bool) */
            creatorRevenueHasBeenWithdrawn: output[2],
            /** totalFundsPendingDistribution (uint256) */
            totalFundsPendingDistribution: output[3],
        };
    },
};
exports.getSellerOf = {
    parseOutput: (output) => {
        return {
            /** seller (address payable) */
            seller: output[0],
        };
    },
};
exports.getWorldsNftAddress = {
    parseOutput: (output) => {
        return {
            /** worldsNft (address) */
            worldsNft: output[0],
        };
    },
};
exports.mintFromDutchAuctionV2 = {
    parseOutput: (output) => {
        return {
            /** firstTokenId (uint256) */
            firstTokenId: output[0],
        };
    },
};
exports.mintFromFixedPriceSaleV2 = {
    parseOutput: (output) => {
        return {
            /** firstTokenId (uint256) */
            firstTokenId: output[0],
        };
    },
};
exports.mintFromFixedPriceSaleWithEarlyAccessAllowlistV2 = {
    parseOutput: (output) => {
        return {
            /** firstTokenId (uint256) */
            firstTokenId: output[0],
        };
    },
};
//# sourceMappingURL=NFTDropMarketHelpers.generated.js.map